var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutoDispatch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#1080FF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.319 3.195a.477.477 0 1 0-.675.675 5.117 5.117 0 0 1 1.51 3.645 5.119 5.119 0 0 1-1.51 3.646 5.121 5.121 0 0 1-3.645 1.51 5.124 5.124 0 0 1-3.646-1.51 5.121 5.121 0 0 1-1.51-3.646 5.12 5.12 0 0 1 1.51-3.645.477.477 0 0 0-.674-.675 6.068 6.068 0 0 0-1.79 4.32c0 1.632.635 3.167 1.79 4.32a6.07 6.07 0 0 0 4.32 1.79 6.07 6.07 0 0 0 4.32-1.79 6.071 6.071 0 0 0 1.79-4.32 6.07 6.07 0 0 0-1.79-4.32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.998 10.829a3.307 3.307 0 0 0 3.27-3.86.478.478 0 0 0-.942.158c.126.75-.12 1.52-.657 2.057-.92.921-2.419.922-3.34 0a2.367 2.367 0 0 1-.659-2.057.478.478 0 1 0-.941-.157 3.32 3.32 0 0 0 .924 2.889c.647.646 1.497.97 2.345.97z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.998 4.481a.71.71 0 0 1-.713-.705c0-.4.322-.721.713-.721.391 0 .713.322.713.72a.71.71 0 0 1-.713.706zm0 2.494c.522 0 2.393-1.59 2.393-3.207a2.398 2.398 0 0 0-2.393-2.393 2.398 2.398 0 0 0-2.393 2.393c0 1.616 1.871 3.207 2.393 3.207z",
    fill: "#1080FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoDispatch);
export default __webpack_public_path__ + "static/media/auto_dispatch.d454c665e76e28f4438c800687cddc9e.svg";
export { ForwardRef as ReactComponent };